import { generateTypes } from '../../utils/HttpReducerHelper';

export const dueActivitiesCount = generateTypes('FUNDING_SEARCH', 'DUE_ACTIVITIES_COUNT');
